/* Section "Collections à onglets" — switch d'onglets + lazy-load.
   Seul le premier panneau est rendu côté serveur. Les autres portent un
   data-url (Section Rendering API) : au premier affichage, on fetch la
   section dans le contexte de la collection de l'onglet et on injecte le
   panneau correspondant. Les slide-section injectés s'initialisent
   automatiquement (custom element + lazy-init IntersectionObserver). */
if (!customElements.get("collection-tabs")) {
  customElements.define(
    "collection-tabs",
    class CollectionTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll(".fc-tab-btn"));
        this.panes = Array.from(this.querySelectorAll(".fc-tab-pane"));
        this.buttons.forEach((btn) => {
          btn.addEventListener("click", () =>
            this.activate(btn.dataset.tabIndex),
          );
        });
        /* Éditeur de thème : sélectionner un bloc onglet active son panneau */
        document.addEventListener("shopify:block:select", (e) => {
          const btn = this.buttons.find(
            (b) => b.dataset.blockId === e.detail.blockId,
          );
          if (btn) this.activate(btn.dataset.tabIndex);
        });
      }
      activate(index) {
        this.buttons.forEach((b) => {
          const active = b.dataset.tabIndex === index;
          b.classList.toggle("is-active", active);
          b.setAttribute("aria-selected", active ? "true" : "false");
        });
        this.panes.forEach((p) => {
          p.classList.toggle("hidden", p.dataset.tabIndex !== index);
        });
        const pane = this.panes.find((p) => p.dataset.tabIndex === index);
        if (pane) this.loadPane(pane);
        window.dispatchEvent(new Event("resize"));
      }
      loadPane(pane) {
        if (!pane.dataset.url || pane.dataset.loaded) return;
        pane.dataset.loaded = "1";
        fetch(pane.dataset.url)
          .then((r) => {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            const fresh = doc.getElementById(pane.id);
            if (!fresh) throw new Error("pane introuvable");
            pane.innerHTML = fresh.innerHTML;
            /* Les images injectées portent encore data-srcset : l'IntersectionObserver
               du lazyload (module-lazyload.js) ne scanne que le DOM initial, jamais les
               nœuds injectés -> elles restent floues. On réhydrate ici, scopé au pane
               (visible au moment du fetch, donc on charge tout de suite). Réplique la
               logique de module-lazyload.js initLazyLoadImage(). */
            this.hydrateLazyImages(pane);
            window.dispatchEvent(new Event("resize"));
          })
          .catch(() => {
            /* réessayable au prochain clic */
            delete pane.dataset.loaded;
          });
      }
      hydrateLazyImages(pane) {
        pane
          .querySelectorAll("source[data-srcset], img[data-srcset]")
          .forEach((el) => {
            const srcset = el.dataset.srcset;
            if (srcset) {
              el.setAttribute("srcset", srcset);
              el.removeAttribute("data-srcset");
            }
            el.classList.remove("image-lazy-load");
            el.classList.add("lazy-loaded");
          });
        pane.querySelectorAll("img[data-src]").forEach((el) => {
          if (el.dataset.src) {
            el.setAttribute("src", el.dataset.src);
            el.removeAttribute("data-src");
          }
        });
        /* Lève le voile/blur appliqué par .loading sur le wrapper motion-effect */
        pane.querySelectorAll("motion-effect.loading").forEach((m) => {
          m.classList.remove("loading");
          m.classList.add("loaded");
        });
      }
    },
  );
}
